import type { IconDefinition, IconName } from '@fortawesome/fontawesome-svg-core';

const CIRCLE_RING_PATH =
  'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512z';

function invertedCircleIcon(iconName: IconName, innerPath: string): IconDefinition {
  return {
    prefix: 'fas',
    iconName,
    icon: [512, 512, [], '', [CIRCLE_RING_PATH, innerPath]],
  };
}

export const faCirclePlayInverted = invertedCircleIcon(
  'circle-play',
  'M188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z'
);

export const faCirclePauseInverted = invertedCircleIcon(
  'circle-pause',
  'M224 192l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32z'
);

export const faCircleStopInverted = invertedCircleIcon(
  'circle-stop',
  'M192 160l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z'
);
